import { FC } from "react"
import { DLMThreshold } from "../_models"
import { DetailCard, DetailLabelKeysToCells } from "../../../../components/layout"

type Props = {
    details: DLMThreshold
}

const DLM_ROI_DETAILS_FIELDS = {
    id: 'ID',
    dlmType: 'DLM Type',
    cc: 'Company Name',
    threshold: 'Threshold',
    reservedThreshold: 'Reserve'
}

const DLMThresholdDetailsCard: FC<Props> = ({details}) => {
    return(
    <>
    <div className="d-flex flex-row flex-wrap gap-6 mb-4">
        <DetailCard cardTitle="Threshold Details">
            {DetailLabelKeysToCells(DLM_ROI_DETAILS_FIELDS, details)}                        
        </DetailCard>
    </div>
    </>
    )
}

export { DLMThresholdDetailsCard }